import UserList from '../components/units/Main/UserList';

export default function Main(): JSX.Element {
	return (
		<div>
			<UserList />
		</div>
	);
}
